import type { Kapitel, KapitelIndexPost } from '../types'
import kapitelIndexJson from '../content/index.json'

export const kapitelIndex = kapitelIndexJson as KapitelIndexPost[]

const kapitelModuler = import.meta.glob<{ default: Kapitel }>('../content/kapitel/*.json')

export async function laddaKapitel(slug: string): Promise<Kapitel | null> {
  const laddare = kapitelModuler[`../content/kapitel/${slug}.json`]
  if (!laddare) return null
  return (await laddare()).default
}

export function grannKapitel(id: string): { forra: KapitelIndexPost | null; nasta: KapitelIndexPost | null } {
  const publicerade = kapitelIndex.filter((k) => k.publicerad)
  const i = publicerade.findIndex((k) => k.id === id)
  return {
    forra: i > 0 ? publicerade[i - 1] : null,
    nasta: i >= 0 && i < publicerade.length - 1 ? publicerade[i + 1] : null,
  }
}
